import React from 'react'

const ReportsAndExtracts = () => {
  return (
    <div>Reports And Extracts</div>
  )
}

export default ReportsAndExtracts